import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { HistoricoPUTipo, PagamentoResponse } from 'common/genericTypes';
import { Button } from 'm2m.components';
import React from 'react';
import { formatEightDecimalsCurrency } from 'utils/number';

interface HistoricoPUsModalProps {
  pagamento?: PagamentoResponse;
  opened: boolean;
  onClose(): void;
}

const tipoDescriptions: Record<HistoricoPUTipo, string> = {
  [HistoricoPUTipo.Laqus]: 'Laqus',
  [HistoricoPUTipo.Emissor]: 'Emissor',
  [HistoricoPUTipo.AgenteFiduciario]: 'Agente Fiduciário',
};

const formatDataCriacao = (dataCriacao: string): string => {
  const date = new Date(dataCriacao);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const HistoricoPUsModal: React.FC<HistoricoPUsModalProps> = ({
  pagamento,
  opened,
  onClose,
}) => {
  const historico = pagamento?.historicoPUsProjetados ?? [];

  const columns = [
    {
      field: 'dataCriacao',
      headerName: 'Data',
      flex: 1,
      minWidth: 160,
      valueGetter: (params: any) => formatDataCriacao(params.row.dataCriacao),
    },
    {
      field: 'tipo',
      headerName: 'Tipo',
      flex: 0.8,
      minWidth: 130,
      valueGetter: (params: any) => tipoDescriptions[params.row.tipo as HistoricoPUTipo] ?? params.row.tipo,
    },
    {
      field: 'valor',
      headerName: 'Valor',
      flex: 1,
      minWidth: 160,
      valueGetter: (params: any) => formatEightDecimalsCurrency(params.row.valor),
    },
    {
      field: 'usuario',
      headerName: 'Usuário',
      flex: 1,
      minWidth: 150,
      valueGetter: (params: any) => params.row.usuario ?? '-',
    },
    {
      field: 'participante',
      headerName: 'Participante',
      flex: 1.2,
      minWidth: 200,
      valueGetter: (params: any) => params.row.participante ?? '-',
    },
  ];

  return (
    <Dialog open={opened} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h5">Histórico de PUs</Typography>
        <Typography variant="body2" color="textSecondary">
          {`Instrumento: ${pagamento?.instrumentoFinanceiro?.codigo ?? '-'}`}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DataGridPro
          rows={historico}
          columns={columns}
          autoHeight
          hideFooter
          disableSelectionOnClick
          disableColumnMenu
        />
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
